import { AttackSurfaceOption } from './AttackSurfaceSelector.types';

export const DEFAULT_ATTACK_SURFACE_OPTIONS: AttackSurfaceOption[] = [
  {
    label: 'Cloud',
    value: 'cloud',
    tooltip: 'Cloud infrastructure and services',
    description: 'Target cloud infrastructure and services',
  },
  {
    label: 'Code',
    value: 'code',
    tooltip: 'Code repository assets',
    description: 'Target source code for critical risk and hardcoded secrets',
  },
  {
    label: 'Device',
    value: 'device',
    tooltip: 'Devices, iot, and iiot assets and services',
    description: 'Target IoT devices and mobile endpoints',
  },
  {
    label: 'Internet',
    value: 'external',
    tooltip: 'Internet-facing assets and services',
    description:
      'Target publicly accessible domains, IPs, and exposed services',
  },
  {
    label: 'Intranet',
    value: 'internal',
    tooltip: 'Internal intranet network assets and services',
    description: 'Target internal network infrastructure and services',
  },
  {
    label: 'User',
    value: 'users',
    tooltip: 'User accounts and identities',
    description: 'Target user accounts and authentication mechanisms',
  },
  {
    label: 'Web',
    value: 'applications',
    tooltip: 'Web applications and webservices',
    description: 'Target web applications and web services',
  },
];

export const DEFAULT_REQUIRED_OPTIONS: Array<
  keyof import('./AttackSurfaceSelector.types').AttackSurfaceSelection
> = [];
